import TemplateView from '../../TemplateView'
import Button from '../../components/Button'
import messageResource from '../../messageResource'

export default class AddonsMenu extends TemplateView {
    constructor({
        additionalClass = '',
        integrationComponents = [],
        addonsComponents = [],
        mobileComponents = [],
        onUpgradeButtonClick = () => {},
    } = {}) {
        super()

        this.params = {
            additionalClass,
        }

        this.callbacks = {
            onUpgradeButtonClick,
        }

        this.state = {
            showUpgradeSection: false,
            addonsComponents,
            integrationComponents,
            mobileComponents,
        }

        this.onStatePropertyChanged('showUpgradeSection', (showUpgradeSection) => {
            this.$upgradeSection.toggle(showUpgradeSection)
        })

        this.onStatePropertyChanged('addonsComponents', () => {
            if (this.state.addonsComponents.length === 0)
                this.find('.addons').hide()
        })
    }

    templateHtml() {
        return `<div class='addonsMenu <%-additionalClass%>'>
                    <div class='addons'>
                        <div class='title'><%=addonsTitle%></div>
                        <div class='content'/>
                    </div>
                    <div class='mobile'>
                        <div class='title'><%=mobileTitle%></div>
                        <div class='content'/>
                    </div>
                    <div class='integrations'>
                        <div class='title'><%=integrationsTitle%></div>
                        <div class='content'/>
                    </div>
                    <div class='upgradeSection'>
                        <div class='note'>
                            <div class='icon'/>
                            <div class='text'><%=switchToPaid%></div>
                        </div>
                        <div class='button'/>
                    </div>
                </div>`
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
        }
    }

    messageKeys() {
        return {
            integrationsTitle: 'navigator.integrations_menu_title',
            addonsTitle: 'navigator.addons_menu_title',
            mobileTitle: 'navigator.mobile_menu_title',
            switchToPaid: 'menu.addons.switch_to_paid.note',
        }
    }

    afterRender() {
        const $integrationsContent = this.find('.integrations .content')
        this.state.integrationComponents.forEach(component => component.init($integrationsContent))

        const $addonsContent = this.find('.addons .content')
        this.state.addonsComponents.forEach(component => component.init($addonsContent))

        const $mobileContent = this.find('.mobile .content')
        this.state.mobileComponents.forEach(component => component.init($mobileContent))

        this.$upgradeSection = this.find('.upgradeSection')
        new Button({
            additionalClass: 'upgrade',
            label: messageResource.getMessage('menu.addons.switch_to_paid.button'),
            onClickCb: this.callbacks.onUpgradeButtonClick,
        }).init(this.find('.upgradeSection .button'))

        this.renderInitialState()
    }
}



// WEBPACK FOOTER //
// ./web/js/support/addons/AddonsMenu.js